import {
  BERRY_PANEL_FIXED_WIDTH_PX,
  CHAT_LIST_PANEL_WIDTH_PX,
} from 'layout/MainLayout/layout-zoom-constants';
import { CHAT_TOOLS_RAIL_WIDTH_PX } from 'layout/MainLayout/chat-tools-rail-layout';
import { chatListPanelWidthPx, drawerWidth } from 'store/constant';

/** רוחב פאנל רשימת השיחות — צר יותר מהפאנל הכללי (תבניות/כלים). */
export function getChatListPanelWidthSync(): number {
  return chatListPanelWidthPx;
}

/** פאנל תבניות/כלים מהרייל — רוחב Berry המלא (480px), לא כמו רשימת השיחות */
export function getChatSidebarPanelWidthSync(): number {
  return BERRY_PANEL_FIXED_WIDTH_PX;
}

/** גדלים מוצעים לפאנל הרחבה — רשימה סגורה, לא רוחב חופשי, כדי לשמור על עקביות */
export type ExtensionPanelWidth = 'standard' | 'wide' | 'extraWide';

const EXTENSION_PANEL_TARGET_PX: Record<ExtensionPanelWidth, number> = {
  standard: BERRY_PANEL_FIXED_WIDTH_PX,
  wide: 720,
  extraWide: 960,
};

/**
 * מינימום שנשמר לאזור הצ'אט המרכזי. הסף שבו הפאנל נסגר אוטומטית הוא 400px
 * (ראו useCollapseRightWhenChatNarrow); 480 משאיר מרווח ביטחון מעליו.
 */
const CHAT_CENTER_RESERVED_PX = 480;

/**
 * הרוחב בפועל לפאנל הרחבה: הגודל המבוקש, אבל אף פעם לא על חשבון חניקת הצ'אט —
 * במסך צר הפאנל מצטמצם לרוחב הסטנדרטי במקום להיפתח ומיד להיסגר מעצמו.
 */
export function resolveExtensionPanelWidth(
  size: ExtensionPanelWidth = 'standard',
  /** רוחב הפאנל שכבר פתוח (אם יש) — השטח שלו מתפנה כשמחליפים אליו פאנל אחר */
  currentlyOpenPanelPx = 0,
): number {
  const target = EXTENSION_PANEL_TARGET_PX[size] ?? BERRY_PANEL_FIXED_WIDTH_PX;
  if (target <= BERRY_PANEL_FIXED_WIDTH_PX) return BERRY_PANEL_FIXED_WIDTH_PX;
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return BERRY_PANEL_FIXED_WIDTH_PX;
  }

  //* מדידת רוחב חלון השיחה בפועל עדיפה על חישוב לפי רוחב המסך: התפריט הימני
  //* עשוי להיות מכווץ, רשימת השיחות ניתנת לשינוי רוחב, והדפדפן עשוי להיות בזום.
  const measured =
    document.getElementById('chat-header-user-data-box')?.getBoundingClientRect().width ?? 0;

  const available =
    measured > 0
      ? measured + currentlyOpenPanelPx - CHAT_CENTER_RESERVED_PX
      : window.innerWidth -
        (drawerWidth + CHAT_LIST_PANEL_WIDTH_PX + CHAT_CENTER_RESERVED_PX + CHAT_TOOLS_RAIL_WIDTH_PX);

  return Math.max(BERRY_PANEL_FIXED_WIDTH_PX, Math.min(target, Math.round(available)));
}
